import React from 'react';
import GameHeader from '../games/game-header';
import { global_var } from '../../services/cs-lab-config';

const AIForOceans = () => {

  document.title = "CS Lab | AI for Oceans";

  return (
    <div className="container-fluid p-0">
      <div className="row mt-1">
        <div className="col">
          <GameHeader headerName="AI for Oceans" />
          <iframe
            id="tuxPaintIframe"
            src={`${global_var.AI_FOR_OCEANS_ENDPOINT}?userId=${global_var.user_login_id}`}
            title="AI for Oceans"
            style={{
              width: '100%',
              height: 'calc(100vh - 80px)',
              border: 'none',
              display: 'block',
            }}
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default AIForOceans;
